module.exports = __webpack_public_path__ + "CADRlogo.e7c7013fdcc3ab0071c3.svg";